const _DefaultExceptionEventData = class _DefaultExceptionEventData {
  constructor(event) {
    this.event = event;
  }
  getType() {
    return this.getTitleException().type ?? _DefaultExceptionEventData.UNKNOWN_TYPE;
  }
  getValue() {
    return this.getTitleException().value ?? _DefaultExceptionEventData.UNKNOWN_VALUE;
  }
  getLevel() {
    return this.event.level ?? _DefaultExceptionEventData.UNKNOWN_LEVEL;
  }
  getFingerPrint() {
    return this.event.fingerprint ?? ["{{ default }}"];
  }
  getExtra() {
    return void 0;
  }
  getTitleException() {
    const exceptions = this.event.exception?.values ?? [];
    const lastException = exceptions[exceptions.length - 1];
    if (lastException === void 0) {
      console.warn(
        "[packages/linear] lastException === undefined \uC778 \uC0C1\uD669\uC774 \uC758\uB3C4\uC778\uC9C0 \uD655\uC778\uD574 \uC8FC\uC138\uC694."
      );
    }
    return exceptions.length > 0 ? lastException : {};
  }
};
_DefaultExceptionEventData.UNKNOWN_TYPE = "Unknown Type";
_DefaultExceptionEventData.UNKNOWN_VALUE = "Unknown Value";
_DefaultExceptionEventData.UNKNOWN_LEVEL = "error";
let DefaultExceptionEventData = _DefaultExceptionEventData;

export { DefaultExceptionEventData as default };
//# sourceMappingURL=DefaultEvent.mjs.map
